import { ForgotPassword } from "./pages/ForgotPassword";
import { Login } from "./pages/Login";
import { Onboard } from "./pages/Onboard";
import { ResetPassword } from "./pages/ResetPassword";
import { forms } from "./shared/forms";
import { general } from "./shared/general";

export const no = {
	pages: {
		login: Login,
		forgot_password: ForgotPassword,
		reset_password: ResetPassword,
		onboard: Onboard,
	},
	shared: {
		general,
		forms,
	},
};
